import styled, { css } from 'styled-components';
import { themeGet } from '@magalu/stereo-ui-styles';
import { Flex, Input, Button } from '../../atoms';
const defaultStyles = css`
  font-size: ${themeGet('fontSizes.1')}px;
  border-radius: 12px;
  padding: 12px 16px;
  height: 40px;
`;
export const Form = styled(Flex).attrs(() => ({
  as: 'form'
}))`
  width: 100%;
`;
export const Row = styled(Flex)`
  width: 100%;
  gap: ${themeGet('space.3')}px;
  margin-bottom: ${themeGet('space.3')}px;
  min-height: 14px;
`;
export const LicensePlateInput = styled(Input)`
  border-radius: 8px;
  padding: 12px 16px;
  height: 40px;
  width: auto;
  color: ${themeGet('colors.gray')};
  ::placeholder,
  ::-webkit-input-placeholder {
    color: ${themeGet('colors.gray')};
  }
`;
export const LicensePlateButton = styled(Button)`
  ${defaultStyles}
`;
export const LicensePlateLink = styled(Button)`
  ${defaultStyles}
`;